import {Component, OnInit, Input} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {APIService, PermissionType} from 'src/app/API.service';
import {Router} from '@angular/router';
import {SessionService} from '../../../services/session.service';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {User, Contract, Bonus, BonusStatus, Team} from '../../../../models';
import {Roles, Percentages} from '../../../enums/enums';
import {Predicates} from 'aws-amplify';
import {EditPaymentComponent} from "../../edit-payment/edit-payment.component";

@Component({
    selector: 'app-list-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {
    @Input() owner: any;
    @Input() type: string = 'contract';

    contractsList: Bonus[] = [];
    filteredContractList: Bonus[];
    cssClass: string = 'asd';
    b = BonusStatus;
    p;
    usernams = {};

    constructor(
        public navController: NavController,
        public apiService: APIService,
        public sessionService: SessionService,
        public router: Router,
        public modalController: ModalController,
    ) {
    }

    async ngOnInit() {
        this.p = Percentages;
        this.refreshContractList();
    }

    private async refreshContractList() {
        // const currentUser = this.sessionService.getCurrentUser();
        // this.contractsList =  await (await DataStore.query(Contract)).filter(c => { return c.userID == this.sessionService.user?.id });
        const contracts = await DataStore.query(Bonus, Predicates.ALL, {sort: s => s.status(SortDirection.ASCENDING).payDate(SortDirection.ASCENDING)});
        

        // let's filter all if no owner is specified
        let filter =    c => {
            return true;
        };
        if (this.owner) {
            filter = c => {
                return c.userContractsAddedId == this.owner.id;
            };

            if (this.owner.permessions == 'CLIENT' || this.type == 'investment') {
                filter = c => {
                    return c.userID == this.owner.id;
                };
            }
        }

        this.contractsList = this.filteredContractList = contracts.filter(filter);
        for (let f of this.contractsList) {
            // this.usernams[f.userBonusId] = await this.getPaymentName(f.userBonusId);
            if (f.user?.id){
                this.usernams[f.user?.id] = await this.getPaymentName(f.user?.id);

            }
        }
    }

    async filterPayments(filters) {
        

        if (filters['name'].trim().length == 0 && filters['status'].length == 0) {
            this.filteredContractList = this.contractsList;
            return;
        }

        this.filteredContractList = await this.contractsList.filter(u => {
            let matcheNames = '.+';
            let matcheStatus = true;


            if (filters['name'].trim().length != 0)
                matcheNames = filters['name'].toLowerCase();
            const reName = new RegExp(matcheNames, 'gi');

            if (filters['status'] != 'Tutti') {
                matcheStatus = u.status == filters['status'];
            }

            // make sure we don't take into account users with no name
            // if(!u.userContractsAddedId || !u.commercial.lastname || !u.status) return false;

            // const bonusUser = await (await DataStore.query(User, user => user.id("eq", u.userID)))[0];


            return (`${u.info.toLowerCase()}`.match(reName) ||`${u.user?.name?.toLowerCase()} ${u.user?.lastname?.toLowerCase()}`.match(reName) ) && matcheStatus;
            // return `${bonusUser.name} ${bonusUser.lastname}`.match(reName) && matcheStatus;
        });
    }


    editPayment(payment) {
        this.openEditPaymentModal(payment.id);
    }

    addPayment() {
        this.openEditPaymentModal(null);
    }

    private async openEditPaymentModal(contractId: any) {
        const modal = await this.modalController.create({
            component: EditPaymentComponent,
            componentProps: {id: contractId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshContractList();
        });
    }

    async deleteContract(contractId: string) {
        this.cssClass = '';

        if (confirm('Do you really want to delete this Bonus')) {
            await DataStore.delete(Bonus, contractId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshContractList();
            }, 1000);
        }
    }

    async getPaymentName(userId) {
        let x = await DataStore.query(User, userId);

        return x.name + ' ' + x.lastname;
    }

    identify(inde, item) {
        return item.id;
    }

   async payed(payment: Bonus) {
        await DataStore.save(Bonus.copyOf(payment,up => {
            up.status = BonusStatus.PAGATO;
        }));
       await this.refreshContractList();
        
    }

   async delete(payment: Bonus) {
        if (confirm('Sicuro di voler cancellare il pagamento?')) {
            await DataStore.delete(Bonus, payment.id);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshContractList();
            }, 1000);
        }
    }
}
